import { render, staticRenderFns } from "./MyItems.vue?vue&type=template&id=5c66e7c2&scoped=true&"
import script from "./MyItems.vue?vue&type=script&lang=js&"
export * from "./MyItems.vue?vue&type=script&lang=js&"
import style0 from "./MyItems.vue?vue&type=style&index=0&id=5c66e7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66e7c2",
  null
  
)

export default component.exports